"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionRow = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var styled_components_1 = __importDefault(require("styled-components"));
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var models_1 = require("../../models");
var utilities_1 = require("../../utilities");
var common_1 = require("../common");
var response_options_1 = require("../response-options");
var QuestionVariationRow_1 = require("./QuestionVariationRow");
var Tag = styled_components_1.default.div.attrs({
    className: 'tws-question-tag',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t {\n\t\tfloat: left;\n\t\tborder-radius: 3px;\n\t\tpadding: 5px;\n\t\tmargin: 3px;\n\t\tbackground-color: #666;\n\t\tcolor: #fff;\n\t}\n"], ["\n\t {\n\t\tfloat: left;\n\t\tborder-radius: 3px;\n\t\tpadding: 5px;\n\t\tmargin: 3px;\n\t\tbackground-color: #666;\n\t\tcolor: #fff;\n\t}\n"])));
Tag.displayName = 'Tag';
var QuestionRow = /** @class */ (function (_super) {
    __extends(QuestionRow, _super);
    function QuestionRow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            visibleColumns: utilities_1.ColumnHelper.GetSelectedColumns(_this.props.columns),
        };
        _this.GetQuestionVariationRows = _this.GetQuestionVariationRows.bind(_this);
        _this.GetMissingBenchmarks = _this.GetMissingBenchmarks.bind(_this);
        _this.GetMissingLanguages = _this.GetMissingLanguages.bind(_this);
        return _this;
    }
    QuestionRow.getDerivedStateFromProps = function (props) {
        var visibleColumns = utilities_1.ColumnHelper.GetSelectedColumns(props.columns);
        return { visibleColumns: visibleColumns };
    };
    QuestionRow.prototype.render = function () {
        var _this = this;
        var selectable = this.props.selectable;
        var _a = this.props.question, questionId = _a.questionId, questionVariationId = _a.questionVariationId, sourceType = _a.sourceType;
        var isSelected = false;
        if (lodash_1.default.isEqual(sourceType, models_1.SourceType.KincentricLibrary) || lodash_1.default.isEqual(sourceType, models_1.SourceType.ClientLibrary)) {
            isSelected = questionVariationId ? this.props.selectedQuestionVariationIds.indexOf(questionVariationId) > -1 : false;
        }
        else {
            isSelected = this.props.selectedCustomQuestionIds.indexOf(questionId) > -1;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(aon_tws_common_ui_1.TableRow, { disabled: this.props.disabled, expanded: this.props.question.showVariations, key: this.props.question.code, onSelectRow: function () { return _this.props.SelectQuestion(_this.props.question, !isSelected); }, record: this.props.question, selectable: selectable, selected: isSelected }, (0, lodash_1.default)(this.state.visibleColumns)
                .sortBy('displayOrder')
                .map(function (column) { return _this.getQuestionPropertyText(column, isSelected); })
                .value()),
            this.GetQuestionVariationRows()));
    };
    QuestionRow.prototype.GetQuestionVariationRows = function () {
        var _this = this;
        if (this.props.question.showVariations === false ||
            this.props.question.questionVariations === undefined ||
            !this.props.question.questionVariations.length) {
            return null;
        }
        return lodash_1.default.map(this.props.question.questionVariations, function (questionVariation) { return (React.createElement(QuestionVariationRow_1.QuestionVariationRow, __assign({}, _this.props, { QuestionVariation: questionVariation, SelectQuestionVariation: function (isSelected) {
                return _this.props.SelectQuestionVariation(_this.props.question, questionVariation, isSelected);
            }, isSelected: _this.props.selectedQuestionVariationIds.indexOf(questionVariation.questionVariationId) > -1, variationActionMenu: _this.props.variationActionMenu, key: questionVariation.questionVariationId }))); });
    };
    QuestionRow.prototype.getAlternateVersionsContent = function () {
        var variationCount = this.props.question.alternateVersions;
        return (React.createElement(common_1.CounterDisplayWithToggle, { count: variationCount, onClick: this.props.ShowSingleVariation, id: this.props.question.questionId, open: this.props.question.showVariations }));
    };
    QuestionRow.prototype.getTagsContent = function () {
        if (!this.props.question.tagNames || !this.props.question.tagNames.length) {
            return React.createElement("span", null);
        }
        return this.props.question.tagNames.map(function (tag, index) { return React.createElement(Tag, { key: index }, tag); });
    };
    QuestionRow.prototype.getBenchmarkContent = function () {
        var questionId = this.props.question.questionId;
        if (this.props.normCounts && this.props.normCounts.has(questionId)) {
            var normCount = this.props.normCounts.get(questionId) || 0;
            return (React.createElement(React.Fragment, null,
                normCount,
                normCount > 0 ? (React.createElement(common_1.ModalOpenButton, { id: this.props.question.questionId, text: this.props.question.text, OpenModalCallback: this.props.BenchmarksModalOpen })) : null));
        }
        return 0;
    };
    QuestionRow.prototype.getLanguageContent = function () {
        var languageCount = this.props.question.languageCount;
        if (this.props.hideLanguageModalIcon) {
            return languageCount > 0 ? React.createElement(React.Fragment, null, languageCount) : 0;
        }
        else {
            return languageCount > 0 ? (React.createElement(React.Fragment, null,
                languageCount,
                React.createElement(common_1.ModalOpenButton, { id: this.props.question.questionVariationId, text: this.props.question.text, OpenModalCallback: this.props.LanguagesModalOpen }))) : (0);
        }
    };
    QuestionRow.prototype.getQuestionTypeContent = function () {
        var _a = this.props.question, isDemographic = _a.isDemographic, questionType = _a.questionType;
        switch (questionType) {
            case models_1.QuestionType.Scale:
                return isDemographic ? 'Demographic' : 'Scale';
            case models_1.QuestionType.Checkbox:
                return isDemographic ? 'Demographic' : 'Checkbox';
            case models_1.QuestionType.OpenEnded:
                return 'Open Ended';
            case models_1.QuestionType.Ranking:
                return 'Ranking';
            default:
                return 'Scale';
        }
    };
    QuestionRow.prototype.getStatusContent = function () {
        switch (this.props.question.publicationStatus) {
            case 3:
                return models_1.PublicationStatus.Inactive;
            case 2:
                return models_1.PublicationStatus.Public;
            default:
                return models_1.PublicationStatus.Draft;
        }
    };
    // NOTE: The property name and the column name are not always the same.
    // Please use the enum column name values for switch statement
    QuestionRow.prototype.getQuestionPropertyText = function (column, isSelected) {
        var _this = this;
        var _a = this.props, actionMenu = _a.actionMenu, question = _a.question, searchText = _a.searchText;
        var key = question.questionId + '_' + column.name.toLowerCase();
        switch (column.name) {
            case 'code': {
                var code = question.code;
                return (React.createElement(aon_tws_common_ui_1.TableColumn, { key: key },
                    React.createElement(aon_tws_common_ui_1.SearchBolder, { text: code, searchText: searchText })));
            }
            case 'dimensions':
                return (React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, utilities_1.TextHelper.getTextFromArrayProperty(question.dimensionNames, '--', ', ').map(function (d, i) { return (React.createElement(aon_tws_common_ui_1.SearchBolder, { key: i, text: d, searchText: searchText })); })));
            case 'text': {
                var text = question.text;
                return (React.createElement(aon_tws_common_ui_1.TableColumn, { key: key },
                    React.createElement(aon_tws_common_ui_1.SearchBolder, { text: text, searchText: searchText })));
            }
            case 'alternateVersions':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, this.getAlternateVersionsContent());
            case 'tags':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, this.getTagsContent());
            case 'responseOptionGroup':
                return (React.createElement(aon_tws_common_ui_1.TableColumn, { key: key },
                    React.createElement(response_options_1.ResponseOptionsTooltipContainer, { id: question.questionId, invertedTooltip: isSelected, questionType: question.questionType, responseOptionGroup: question.responseOptionGroup, responseOptions: question.responseOptions })));
            case 'questionTemplates':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, utilities_1.TextHelper.getTextFromArrayProperty(question.templateNames, '--', ', '));
            case 'allChosenLanguages': {
                var missingLanguages = this.GetMissingLanguages();
                var tooltipLangId = question.questionId + '_allChosenLanguages';
                return (React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, missingLanguages.length === 0 ? (React.createElement(aon_tws_common_ui_1.Icon, { name: 'yes' })) : (React.createElement(React.Fragment, null,
                    missingLanguages.length + " missing ",
                    React.createElement(aon_tws_common_ui_1.Tooltip, { id: tooltipLangId, iconName: 'error', contentType: 'jsx', inverted: isSelected },
                        React.createElement("div", null,
                            React.createElement("p", null,
                                React.createElement("strong", null, contentConstants_1.default.MISSING_LANGUAGES_TOOLTIP_TITLE_TEXT)),
                            React.createElement("ul", null, missingLanguages.map(function (id, liKey) {
                                var culture = _this.props.availableCultures.find(function (c) { return c.name === id; });
                                return React.createElement("li", { key: liKey }, culture ? culture.displayText : id);
                            })),
                            React.createElement("br", null),
                            contentConstants_1.default.MISSING_LANGUAGES_TOOLTIP_REMINDER_TEXT))))));
            }
            case 'allChosenBenchmarks': {
                var missingBenchmarks = this.GetMissingBenchmarks();
                var tooltipBenchId = question.questionId + '_AllChosenBenchmarksToolTip';
                return (React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, this.props.selectedBenchmarkIds.length === 0 ? ('--') : missingBenchmarks.length === 0 ? (React.createElement(aon_tws_common_ui_1.Icon, { name: 'yes' })) : (React.createElement(React.Fragment, null,
                    missingBenchmarks.length + " missing ",
                    React.createElement(aon_tws_common_ui_1.Tooltip, { id: tooltipBenchId, iconName: 'error', contentType: 'jsx', inverted: isSelected },
                        React.createElement("div", null,
                            React.createElement("p", null,
                                React.createElement("strong", null, contentConstants_1.default.MISSING_BENCHMARK_TOOLTIP_TITLE_TEXT)),
                            React.createElement("ul", null, missingBenchmarks.map(function (id, liKey) {
                                var benchmark = _this.props.availableBenchmarks.find(function (b) { return b.benchmarkId === id; });
                                return React.createElement("li", { key: liKey }, benchmark ? benchmark.displayText : id);
                            })),
                            React.createElement("br", null),
                            contentConstants_1.default.MISSING_BENCHMARK_TOOLTIP_REMINDER_TEXT))))));
            }
            case 'availableBenchmarks':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, this.getBenchmarkContent());
            case 'languages':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, this.getLanguageContent());
            case 'questionType':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, this.getQuestionTypeContent());
            case 'sourceType':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, utilities_1.ColumnHelper.GetSourceTypeContent(question.sourceType));
            case 'publicationStatus':
                return React.createElement(aon_tws_common_ui_1.TableColumn, { key: key }, this.getStatusContent());
            case 'actions':
                return (React.createElement(aon_tws_common_ui_1.TableColumn, { key: key },
                    React.createElement(aon_tws_common_ui_1.ActionMenuWrapper, null, actionMenu && actionMenu(question))));
        }
        return React.createElement(React.Fragment, null);
    };
    QuestionRow.prototype.GetMissingBenchmarks = function () {
        var _this = this;
        if (this.props.question.benchmarkIds) {
            return this.props.selectedBenchmarkIds.filter(function (id) { return _this.props.question.benchmarkIds.indexOf(id) === -1; });
        }
        return [];
    };
    QuestionRow.prototype.GetMissingLanguages = function () {
        var _this = this;
        if (this.props.question.languages) {
            return this.props.supportedCultures.filter(function (id) { return _this.props.question.languages.indexOf(id) === -1; });
        }
        return [];
    };
    return QuestionRow;
}(React.PureComponent));
exports.QuestionRow = QuestionRow;
var templateObject_1;
